import{r as e}from"../../../../_virtual/index23.js";var r,t;r=e,t=e.exports,Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e,r){if(r.length<e)throw new TypeError(e+" argument"+(e>1?"s":"")+" required, but only "+r.length+" present")},r.exports=t.default;
//# sourceMappingURL=index.js.map
